import { Modal } from 'react-bootstrap'
import React from 'react'

const OttPlatformPopUp = props => {
    const { pop, setpop, options1, restrictpop } = props
    return (<>
       {pop && (
        <Modal show={restrictpop} fullscreen={'md-down'} onHide={() => setpop(false)}>
          <Modal.Header closeButton>
            <Modal.Title>OTT platform</Modal.Title>
          </Modal.Header>
          <Modal.Body>{options1}</Modal.Body>
        </Modal>
      )}
      </>)
}

export default OttPlatformPopUp
